import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { postForm } from '../../ajax'

const LoginForm = props => {
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, setValue, formState: { errors }  } = useForm({})
  
  const onSubmit = (data) => {
    setIsLoading(true)
    let formData = new FormData()
    formData.append('authenticity_token', props.authenticityToken)
    for (const key in data) { formData.append(`user[${key}]`, data[key]) }

    postForm('/users/sign_in', formData)
    .then(response => { return response.json() })
    .then((json) => {
      setIsLoading(false)
      if (json.error) {
        props.onError(json.error)
      } else {
        window.location.href = '/admins/reservations'
      }
    })
  }

  return (
    <div className='form-container'>
      <img className='logo' src='/images/new-logo.svg'/>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='input-container'>
          <label>Email:</label>
          <input
            className={errors.email ? 'error' : ''}
            {...register('email', {
              required: 'This field is required',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                message: 'Please enter a valid email address'
              } 
            })}
            onChange={(e) => setValue('email', e.target.value)}
            placeholder='example@email.com'
          />
          {errors.email && <div className='error-container'>{errors.email.message}</div>}
        </div>
        <div className='input-container'>
          <label>Password:</label>
          <input
            className={errors.password ? 'error' : ''}
            type='password'
            {...register('password', { required: 'This field is required' })}
            placeholder='Enter your password'
          />
          {errors.password && <div className='error-container'>{errors.password.message}</div>}
        </div>
        <button className='submit-button' type='submit'>
          {isLoading ? <div className='connection-loader'/> : 'Log in'}
        </button>
      </form>
      <a onClick={props.onRecovery}>Forgot password?</a>
    </div>
  )
}

export default LoginForm
